<template>
  <div v-if="formValidationErrors && formValidationErrors.length > 0" class="col-md-12 pt-3 col-12 mt-2 pb-4 pl-md-5 pl-3 form-outline validation-errors">
    <div class="pl-md-4 pl-2">
      <div class="font-weight-bold mb-2" v-if="!exceptionReceived(formValidationErrors)">Please fix the below errors and re-submit the form.</div>
      <div v-for="(errors, index) in formValidationErrors" :key="index">
        <div>{{errors}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import CONSTANTS from "@/store/constants";

export default {
  name: "FormValidationErrors",
  computed: {
    ...mapGetters(["formValidationErrors"])
  },
  methods: {
    exceptionReceived(formValidationErrors) {
      return formValidationErrors.includes(CONSTANTS.ERROR_MESSAGE)
    }
  }
}
</script>

<style scoped>
.validation-errors {
  background-color: #DD2222;
  color: #fff;
}
</style>